/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { FileId } from "../../commons/types/FileId";
import { JobId } from "../../commons/types/JobId";
import { JobExecutionPlanConfig } from "./JobExecutionPlanConfig";
export const JobExecutionPlanConfigRequest = core.serialization
    .object({
    fileId: FileId.optional(),
    jobId: JobId.optional(),
})
    .extend(JobExecutionPlanConfig);
